enum PortalLinkedItemType {
    None = 0,

    Document = 1,
    Result = 2,
    PrivateBill = 3,
    MedicalNoteForm = 5,
    CommunicationHistory = 7,
    LabRequest = 8,
    ConsultationRequest = 9,
    CnesstForm = 10,
    ObstetricalFile = 11,
    WorkSafeBcForm = 12,
    GrowthChart = 13
}

export { PortalLinkedItemType };
